import { render, staticRenderFns } from "./WallContent.vue?vue&type=template&id=2bf0ccd9&lang=pug"
import script from "./WallContent.vue?vue&type=script&lang=js"
export * from "./WallContent.vue?vue&type=script&lang=js"
import style0 from "./WallContent.vue?vue&type=style&index=0&id=2bf0ccd9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports